import React, { useState, useEffect, useRef } from "react";
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './works.css';

export default function Appnoticia() {
  const [hovered, setHovered] = useState(null);
  const [inView, setInView] = useState(false);
  const sectionRef = useRef(null);

  const NoticiaData = [
    {
      id: 1,
      link: '/noticia/1',
      image: require('../../../assets/Not_23.jpeg'),
      title: 'Encerramento do ano',
      subtitle: 'O Instituto Superior Politécnico Atlântida (ISPA) realizou, no dia 23 de Dezembro de 2025',
      category: 'Novo'
    },
    {
      id: 2,
      link: '/noticia/2',
      image: require('../../../assets/Not_14.jpg'),
      title: 'Visita da comitiva do Instituto Nacional de Avaliação, Acreditação e Reconhecimento de Estudos do Ensino Superior – INAAREES',
      subtitle: 'Esta visita representa uma etapa importante para o fortalecimento da excelência acadêmica e do compromisso institucional do ISPA com a melhoria contínua dos seus cursos, assegurando padrões elevados de formação, investigação e impacto social.',
      category: 'Destaque'
    },
    {
      id: 3,
      link: '/noticia/3',
      image: require('../../../assets/img-hero2.jpeg'),
      title: 'Curso de Curta Duração: O Caminho Rápido para o Sucesso Profissional',
      subtitle: 'Descubra nossos cursos de curta duração, projetados para impulsionar sua carreira e expandir seus horizontes em tempo recorde. Com uma variedade de opções, desde tecnologia até artes, oferecemos aprendizado prático e relevante para o mercado atual. Inscreva-se hoje e dê o próximo passo rumo ao sucesso profissional!',
      category: 'Novo'
    }
  ];

  const styles = {
    galleryContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
      width: '100%'
    },
    noticiaCard: {
      backgroundColor: '#fff',
      borderRadius: '12px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
      overflow: 'hidden',
      transition: 'all 0.3s ease',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      border: '1px solid #eaeaea'
    },
    noticiaCardHover: {
      transform: 'translateY(-5px)',
      boxShadow: '0 8px 24px rgba(0, 118, 31, 0.12)',
    },
    noticiaImageContainer: {
      width: '100%',
      height: '200px',
      overflow: 'hidden',
      position: 'relative'
    },
    noticiaImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transition: 'transform 0.5s ease'
    },
    imageHover: {
      transform: 'scale(1.03)'
    },
    categoryBadge: {
      position: 'absolute',
      top: '12px',
      right: '12px',
      backgroundColor: '#00761F',
      color: 'white',
      padding: '4px 10px',
      borderRadius: '16px',
      fontSize: '0.7rem',
      fontWeight: '600',
      zIndex: 2,
      textTransform: 'uppercase'
    },
    noticiaContent: {
      padding: '16px',
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1
    },
    noticiaTitle: {
      fontSize: '1.1rem',
      marginBottom: '10px',
      fontWeight: '700',
      color: '#00761F',
      lineHeight: '1.4'
    },
    noticiaSubtitle: {
      fontSize: '0.9rem',
      color: '#555',
      marginBottom: '15px',
      lineHeight: '1.5',
      flexGrow: 1
    },
    readMore: {
      color: '#00761F',
      fontWeight: '600',
      fontSize: '0.85rem',
      display: 'inline-flex',
      alignItems: 'center',
      transition: 'all 0.3s ease',
      marginTop: 'auto'
    },
    readMoreHover: {
      transform: 'translateX(3px)'
    },
    galleryGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
      gap: '25px',
      width: '100%',
      justifyContent: 'center', // Centraliza os cards
      justifyItems: 'center', // Centraliza os itens do grid
      margin: '0 auto'
    },
    sectionHeader: {
      textAlign: 'center', // Centraliza o título
      marginBottom: '40px',
      padding: '0 20px'
    },
    sectionTitle: {
      color: '#00761F',
      fontSize: '2rem',
      fontWeight: '700',
      marginBottom: '8px'
    },
    sectionUnderline: {
      height: '3px',
      width: '60px',
      background: 'linear-gradient(90deg, #00761F, #4CAF50)',
      borderRadius: '2px',
      margin: '0 auto' // Centraliza o sublinhado
    },
    sectionSubtitle: {
      color: '#555',
      fontSize: '1rem',
      maxWidth: '600px',
      lineHeight: '1.5',
      margin: '0 auto' // Centraliza o subtítulo
    },
    viewMoreButton: {
      backgroundColor: '#00761F',
      borderColor: '#006a1f',
      color: 'white',
      padding: '12px 28px',
      borderRadius: '50px',
      fontSize: '1.1rem',
      fontWeight: '600',
      letterSpacing: '0.5px',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 15px rgba(0, 118, 31, 0.3)',
      textTransform: 'uppercase',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      textDecoration: 'none',
      '&:hover': {
        backgroundColor: '#006a1f',
        transform: 'translateY(-3px) scale(1.02)',
        boxShadow: '0 8px 25px rgba(0, 118, 31, 0.4)'
      },
      '&:active': {
        transform: 'translateY(1px) scale(0.98)'
      }
    }
  };

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      {
        threshold: 0.1,
        rootMargin: '0px 0px -20% 0px',
      }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <motion.section
      ref={sectionRef}
      id="noticias"
      className="block works-block"
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      style={{ overflow: 'hidden' }} // Previne overflow
    >
      <Container fluid style={{ padding: '40px 0', maxWidth: '100%' }}>
        <div style={{ 
          ...styles.sectionHeader, 
          textAlign: 'center', // Centralizado
          marginBottom: '40px'
        }}>
          <h2 style={{ 
            ...styles.sectionTitle,
            fontSize: '1.70rem',
            fontWeight: '700',
            marginBottom: '8px'
          }}>O que fazemos</h2>
          <div style={{ 
            ...styles.sectionUnderline,
            margin: '0 auto 12px auto' // Centralizado
          }}></div>
        </div>
        <div style={{ ...styles.galleryContainer, padding: '0 20px' }}>
          <div style={styles.galleryGrid}>
            {NoticiaData.map((noticia, index) => (
              <motion.div
                key={noticia.id}
                initial={{ opacity: 0, scale: 0.95 }}
                animate={inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                style={{
                  ...styles.noticiaCard,
                  ...(hovered === noticia.id ? styles.noticiaCardHover : {}),
                  maxWidth: '380px', // Limita a largura máxima dos cards
                  width: '100%' // Garante que ocupe toda a largura disponível
                }}
                onMouseEnter={() => setHovered(noticia.id)}
                onMouseLeave={() => setHovered(null)}
              >
                <Link to={noticia.link} style={{ textDecoration: 'none', height: '100%', display: 'flex', flexDirection: 'column' }}>
                  <div style={styles.noticiaImageContainer}>
                    <Image
                      src={noticia.image}
                      fluid
                      style={{
                        ...styles.noticiaImage,
                        ...(hovered === noticia.id ? styles.imageHover : {})
                      }}
                    />
                    <span style={styles.categoryBadge}>{noticia.category}</span>
                  </div>
                  <div style={styles.noticiaContent}>
                    <h3 style={styles.noticiaTitle}>{noticia.title}</h3>
                    <p style={styles.noticiaSubtitle}>{noticia.subtitle}</p>
                    <span style={{
                      ...styles.readMore,
                      ...(hovered === noticia.id ? styles.readMoreHover : {})
                    }}>
                      Ler mais →
                    </span>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>

          {/* Botão "Ver mais notícias" */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ delay: 0.3, duration: 0.5 }}
            style={{ 
              textAlign: 'center', 
              marginTop: '50px',
              marginBottom: '20px'
            }}
          >
            <Link 
              to="/comunicacao/noticias" 
              style={{
                backgroundColor: '#00761F',
                border: 'none',
                color: 'white',
                padding: '12px 28px',
                borderRadius: '50px',
                fontSize: '1.1rem',
                fontWeight: '600',
                letterSpacing: '0.5px',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(0, 118, 31, 0.3)',
                textTransform: 'uppercase',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                textDecoration: 'none',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#006a1f';
                e.target.style.transform = 'translateY(-3px) scale(1.02)';
                e.target.style.boxShadow = '0 8px 25px rgba(0, 118, 31, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#00761F';
                e.target.style.transform = 'translateY(0) scale(1)';
                e.target.style.boxShadow = '0 4px 15px rgba(0, 118, 31, 0.3)';
              }}
              onMouseDown={(e) => {
                e.target.style.transform = 'translateY(1px) scale(0.98)';
              }}
              onMouseUp={(e) => {
                e.target.style.transform = 'translateY(-3px) scale(1.02)';
              }}
            >
              Ver todas as notícias
              <i className="fas fa-arrow-right" style={{ marginLeft: '8px' }}></i>
            </Link>
          </motion.div>
        </div>
      </Container>
    </motion.section>
  );
}